/**
 * Short Notes API Service
 * Fetches and generates AI-powered short notes for chapters
 */

import axios from 'axios';
import { getAuthToken, getPortalType } from '../utils/auth';
import { API_BASE_URL } from './config';

// Get auth token from localStorage
const getAuthHeaders = () => {
  const portal = getPortalType(window.location.pathname || '');
  const token = getAuthToken(portal);
  return {
    'Authorization': token ? `Bearer ${token}` : '',
    'Content-Type': 'application/json'
  };
};

// Short Notes API
export const shortNotesAPI = {
  /**
   * Generate short notes for a chapter
   * @param {number} chapterId - The chapter ID
   * @param {boolean} usePdf - Whether to extract text from PDF (default: true)
   * @returns {Promise<{title: string, sections: Array}>}
   */
  generate: async (chapterId, usePdf = true) => {
    try {
      const response = await axios.post(
        `${API_BASE_URL}/core/chapters/short-notes/`,
        {
          chapter_id: chapterId,
          use_pdf: usePdf,
        },
        {
          headers: getAuthHeaders(),
        }
      );
      return response.data;
    } catch (error) {
      console.error('Error generating short notes:', error);
      if (error.response) {
        console.error('Response status:', error.response.status);
        console.error('Response data:', error.response.data);
      }
      throw error;
    }
  },
};

